import { normalizeBaseHome } from './normalize-base-home'

export const normalizeBaseCategory = (rawData) => {
  return normalizeBaseHome(rawData)
}
